import { Bot } from "lucide-react";
import LogoDeepSeek from "./LogoDeepSeek";
import LogoKimi from "./LogoKimi";
import LogoZai from "./LogoZai";
import LogoMeta from "./LogoMeta";
import LogoQwen from "../../../../assets/icons/LogoQwen";

const NebiusChatAvatar = ({ modelId, size = 24, color = "#000" }) => {
  const renderLogo = () => {
    if (modelId?.startsWith("direct:nebius.deepseek-ai")) {
      return <LogoDeepSeek size={size} />;
    } else if (modelId?.startsWith("direct:nebius.moonshotai")) {
      return <LogoKimi size={size} />;
    } else if (modelId?.startsWith("direct:nebius.zai-org")) {
      return <LogoZai size={size} />;
    } else if (modelId?.startsWith("direct:nebius.meta-llama")) {
      return <LogoMeta size={size} />;
    } else if (modelId?.startsWith("direct:nebius.Qwen/")) {
      return <LogoQwen size={size} />;
    } else {
      return <Bot size={size} color={color} />;
    }
  };

  return <div className="nebius_avatar">{renderLogo()}</div>;
};

export default NebiusChatAvatar;
